import ContentEdit from './ContentEdit';

import Actions from './Actions';
import Header from './Header';
import Detail from './Detail';
import Side from './Side';
import Section from './Section';

export {
  Actions,
  Header,
  Detail,
  Side,
  Section
};

export default ContentEdit;



// WEBPACK FOOTER //
// ./src/components/admin/ContentEdit/index.js